<div class="success-screen">
  <div class="success-content">
    <div class="success-icon-wrapper">
      <div class="success-icon-circle">
        <cm-icon name="check" aria-hidden="true" />
      </div>
    </div>

    <h1 class="success-title">{{ title() }}</h1>

    <p class="success-message">
      @if (entityName()) {
        <strong>{{ entityName() }}</strong>
      }
      {{ message() }}
    </p>

    <div class="success-actions">
      <cm-button
        variant="flat"
        color="primary"
        (click)="primaryClick.emit()"
        [autId]="primaryAutId()"
      >
        @let icon = primaryIcon();
        @if (icon) {
          <cm-icon [name]="icon" aria-hidden="true" />
        }
        {{ primaryLabel() }}
      </cm-button>
      <cm-button
        variant="stroked"
        color="primary"
        (click)="secondaryClick.emit()"
        [autId]="secondaryAutId()"
      >
        {{ secondaryLabel() }}
      </cm-button>
    </div>
  </div>
</div>
